<template>
  <v-card>
    <v-layout wrap pt-4 ml-3>
      <v-flex xs12 sm8 md4>
        <v-text-field
          v-model="template.name"
          outlined
          dense
          label="Template Name"
          class="pl-4"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap ml-3>
      <v-flex xs12 sm8 md4>
        <v-text-field
          v-model="template.description"
          outlined
          dense
          label="Template Description"
          class="pl-4"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap pa-4>
      <v-flex xs12 sm8 child-flex>
        <products-table
          :headers="productTableHeaders"
          :actions="productTableActions"
        />
      </v-flex>
      <v-flex v-if="template" xs12 sm4>
        <v-card class="ml-2 elevation-0">
          <v-card-title>Template Items</v-card-title>
          <v-list three-line>
            <v-list-item
              three-line
              v-for="(item, index) in template.items"
              :key="index"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.productCode }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.manufacturer }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ item.category.name }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ item.description[0].value }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon @click="removeItem(item)">
                <v-icon color="error">delete</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item v-if="!template.items.length">
              <v-list-item-content>
                <v-list-item-title
                  >No items have been added to this template.</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 text-sm-right>
        <v-btn @click="saveTemplate" color="primary" :disabled="!dataChanged"
          >Save</v-btn
        >
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import request from "@/modules/request";
import ProductsTable from "@/components/ProductsTable";

export default {
  name: "AssociateTemplate",
  inject: ["snackBar"],
  components: {
    ProductsTable,
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    dataChanged() {
      return (
        JSON.stringify(this.savedTemplate) !== JSON.stringify(this.template)
      );
    },
  },
  data() {
    return {
      advancedSearchOptions: [],
      template: null,
      selectedTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "",
          value: "action",
        },
      ],
      selectedTableActions: [
        {
          color: "error",
          click: this.removeItem,
          text: "",
          icon: "delete",
        },
      ],
      productTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      productTableActions: [
        {
          color: "primary",
          click: this.addItem,
          text: "",
          icon: "add",
        },
      ],
      savedTemplate: {},
    };
  },
  methods: {
    getCategories() {
      const opts = {
        method: "get",
      };
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/fullcategories",
        })
        .then((results) => {
          return results.data;
        });
    },
    generateAdvancedSearchOptions() {
      const { categories } = this;
      const options = [
        {
          component: "v-select",
          label: "Select Category",
          items: categories,
          value: "_id",
          key: "category",
          model: "catalog",
          text: "name",
        },
      ];
      this.advancedSearchOptions = options;
    },
    async loadData() {
      const { getTemplate, getCategories } = this;
      const results = await Promise.all([getTemplate(), getCategories()]).catch(
        (error) => {
          console.error(error);
        }
      );

      const [template, categories] = results;
      this.template = template;
      this.categories = categories;
      this.savedTemplate = JSON.parse(JSON.stringify(template));
    },
    async getTemplate() {
      const templateId = this.$route.params.id;
      return request
        .callInternal({
          method: "get",
          route: `/api/template/${templateId}`,
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addItem(item) {
      const added = this.template.items.find(
        (product) => product._id === item._id
      );
      if (!added) {
        this.template.items.push(item);
        this.snackBar("Item added", "success");
      } else {
        this.snackBar("Item already added", "error");
      }
    },
    removeItem(item) {
      this.template.items = this.template.items.filter(
        (product) => product._id !== item._id
      );
    },
    async saveTemplate() {
      const templateId = this.$route.params.id;
      const { name, description, items } = this.template;
      await request
        .callInternal({
          method: "patch",
          route: `/api/template/${templateId}`,
          data: {
            name,
            description,
            items,
          },
        })
        .then(() => {
          this.snackBar("Saved!", "success");
          this.loadData();
        })
        .catch((error) => {
          console.error(error);
          this.snackBar("Sorry, something went wrong!", "error");
          this.loadData();
        });
    },
  },
};
</script>
